var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGrid48Filled = function SvgIconGrid48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 9.3h-2.8a5.3 5.3 0 0 0-5.3 5.3v2.8a5.3 5.3 0 0 0 5.3 5.3h2.8a5.3 5.3 0 0 0 5.3-5.3v-2.8a5.3 5.3 0 0 0-5.3-5.3ZM33.4 9.3h-2.8a5.3 5.3 0 0 0-5.3 5.3v2.8a5.3 5.3 0 0 0 5.3 5.3h2.8a5.3 5.3 0 0 0 5.3-5.3v-2.8a5.3 5.3 0 0 0-5.3-5.3ZM17.4 25.3h-2.8a5.3 5.3 0 0 0-5.3 5.3v2.8a5.3 5.3 0 0 0 5.3 5.3h2.8a5.3 5.3 0 0 0 5.3-5.3v-2.8a5.3 5.3 0 0 0-5.3-5.3ZM33.4 25.3h-2.8a5.3 5.3 0 0 0-5.3 5.3v2.8a5.3 5.3 0 0 0 5.3 5.3h2.8a5.3 5.3 0 0 0 5.3-5.3v-2.8a5.3 5.3 0 0 0-5.3-5.3Z",
    fill: "current"
  })));
};
export default SvgIconGrid48Filled;